const css = `.GSwxRG__notificationItem{border:1px solid var(--base-strokes-default);background-color:var(--base-surfaces-default);border-radius:4px}.GSwxRG__iconContainer{height:24px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"iconContainer":"GSwxRG__iconContainer","notificationItem":"GSwxRG__notificationItem"};
